module.exports = __webpack_public_path__ + "static/media/add-block-above.fc705d4c.svg";